<template>
  <v-flex>
    <vue-markdown
      class="mb-4 px-2"
      :html="true"
      v-if="getTemplateByName('THIRD_STEP_HEADER_CONTENT') != null"
    >{{getTemplateByName("THIRD_STEP_HEADER_CONTENT").content}}</vue-markdown>

    <v-form v-model="thirdStepFinished" ref="form">
      <v-col cols="12" class="pb-0">
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-text-field
            :value="firstName"
            @change="v => firstName = v"
            placeholder="First Name"
            prepend-icon="account_circle"
            :rules="rules.firstNameRules"
            name="given-name"
            id="given-name"
            autocomplete="given-name"
          >
            <span slot="label">
              First Name
              <font color="red">*</font>
            </span>
          </v-text-field>
        </div>
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-text-field
            :value="lastName"
            @change="v => lastName = v"
            placeholder="Last Name"
            prepend-icon="account_circle"
            :rules="rules.lastNameRules"
            name="family-name"
            id="family-name"
            autocomplete="family-name"
          >
            <span slot="label">
              Last Name
              <font color="red">*</font>
            </span>
          </v-text-field>
        </div>
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-text-field
            :value="email"
            @change="v => email = v"
            placeholder="Email"
            hint="Invoice will be sent to the following email"
            prepend-icon="mail"
            :rules="rules.emailRules"
            type="email"
            name="email"
            id="email"
            autocomplete="home email"
          >
            <span slot="label">
              E-mail
              <font color="red">*</font>
            </span>
          </v-text-field>
        </div>
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-text-field
            :value="phone"
            @change="v => phone = v"
            placeholder="Phone"
            prepend-icon="local_phone"
            :rules="rules.phoneRules"
            type="number"
            name="tel"
            id="tel"
            autocomplete="home tel"
          >
            <span slot="label">
              Phone
              <font color="red">*</font>
            </span>
          </v-text-field>
        </div>
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-autocomplete
            placeholder="Country"
            :value="country"
            @change="v => country = v"
            :items="countryList.getNames()"
            item-text="label"
            prepend-icon="location_city"
            :rules="rules.countryRules"
            autocomplete="off"
            attach
          >
            <span slot="label">
              Country
              <font color="red">*</font>
            </span>
          </v-autocomplete>
        </div>
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-text-field
            v-if="isCompany == false"
            :value="address"
            @change="v => address = v"
            placeholder="Address"
            prepend-icon="location_city"
            :rules="rules.requiredRule128"
            name="address-line1"
            id="address-line1"
            autocomplete="shipping address-line1"
          >
            <span slot="label">
              Address
              <font color="red">*</font>
            </span>
          </v-text-field>
        </div>
      </v-col>

      <div v-if="isCompany == true">
        <v-col cols="12" class="py-0">
          <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
            <v-text-field
              :value="companyName"
              @change="v => companyName = v"
              placeholder="Company Name"
              prepend-icon="work"
              :rules="rules.requiredRule128"
              name="organization"
              id="organization"
              autocomplete="organization"
            >
              <span slot="label">
                Company Name
                <font color="red">*</font>
              </span>
            </v-text-field>
          </div>
          <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
            <v-text-field
              :value="companyAddress"
              @change="v => companyAddress = v"
              placeholder="Company Address"
              prepend-icon="work"
              :rules="rules.requiredRule128"
            >
              <span slot="label">
                Company Address
                <font color="red">*</font>
              </span>
            </v-text-field>
          </div>
          <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
            <v-text-field
              :value="registrationNumber"
              @change="v => registrationNumber = v"
              placeholder="Registration Number"
              prepend-icon="work"
              :rules="rules.requiredRule128"
            >
              <span slot="label">
                Registration Number
                <font color="red">*</font>
              </span>
            </v-text-field>
          </div>
          <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
            <v-text-field
              :value="vatNumber"
              @change="v => vatNumber = v"
              placeholder="VAT payer number"
              prepend-icon="work"
              :rules="rules.vatNumberRules"
            >
              <span slot="label">
                VAT payer number
                <font color="red">*</font>
              </span>
            </v-text-field>
          </div>
          <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
            <v-text-field
              v-model="iban"
              prepend-icon="work"
              placeholder="LV80BANK0000435195001"
              :rules="rules.ibanRules"
            >
              <span slot="label">
                IBAN
                <font v-if="iban != null && iban.length > 0" color="red">*</font>
              </span>
            </v-text-field>
          </div>
          <div v-if="iban != null && iban.length > 0">
            <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
              <v-text-field
                :value="bank"
                @change="v => bank = v"
                prepend-icon="work"
                placeholder="Bank"
                :rules="rules.bankRules"
              >
                <span slot="label">
                  Bank
                  <font color="red">*</font>
                </span>
              </v-text-field>
            </div>
            <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
              <v-text-field
                :value="bic"
                @change="v => bic = v"
                prepend-icon="work"
                placeholder="BANKLV32"
                :rules="rules.bicRules"
              >
                <span slot="label">
                  SWIFT/BIC
                  <font color="red">*</font>
                </span>
              </v-text-field>
            </div>
          </div>
        </v-col>
      </div>
      <v-col cols="12">
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-checkbox
            v-model="agreeTermsAndConditions"
            color="primary"
            class="terms-checkbox"
            :rules="rules.requiredRule"
          >
            <span slot="label">
              I agree with the
              <a
                target="_blank"
                rel="noopener noreferrer"
                @click.stop
                href="https://docs.google.com/document/d/1ZlZWympjgqce5NasiM55UK5mOfLbP0F6wFcLgWZIqnA/edit?usp=sharing"
              >terms of use and the personal data processing rules.</a>
              <font color="red">&nbsp;*</font>
            </span>
          </v-checkbox>
        </div>
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-checkbox
            v-model="agreeDataTerms"
            color="primary"
            class="terms-checkbox"
            :rules="rules.requiredRule"
          >
            <span slot="label">
              I agree to submit personal information for conference organisers.
              <font color="red">*</font>
            </span>
          </v-checkbox>
        </div>
        <div :data-aos="inputFieldAnimation" :data-aos-offset="inputFieldOffset">
          <v-checkbox
            v-model="agreeMailingList"
            color="primary"
            class="terms-checkbox"
            :rules="rules.requiredRule"
          >
            <span slot="label">
              I agree for attendees to be added to event mailing list to receive important updates about the conference.
              <font
                color="red"
              >*</font>
            </span>
          </v-checkbox>
        </div>
      </v-col>
    </v-form>

    <v-layout row>
      <div data-aos="fade-left" data-aos-offset="30">
        <v-btn class="ma-3" @click.native="scrollToTop;currentStep = 2;">
          <v-icon left>navigate_before</v-icon>Back
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div data-aos="fade-right" data-aos-offset="30">
        <v-btn class="ma-3" color="primary" :disabled="!thirdStepFinished" @click.native="nextStep">
          Continue
          <v-icon right>navigate_next</v-icon>
        </v-btn>
      </div>
    </v-layout>
  </v-flex>
</template>

<script>
import helperMethods from "../mixins/helperMethods";
import clientData from "../mixins/clientData";
import allRules from "../mixins/allRules";
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  data() {
    return {
      thirdStepFinished: false,
      inputFieldOffset: 10,
      inputFieldAnimation: "fade-right"
    };
  },
  mixins: [helperMethods, clientData, allRules],
  methods: {
    nextStep() {
      this.$gtm.trackEvent({
        category: "client-data-continue-button",
        action: "click",
        noninteraction: false
      });
      this.scrollToTop();
      this.showPayments = true;
    }
  }
};
</script>

<style>
</style>